<ng-template #timezoneforFreelauncher>
  <div class="common-header-flex">
    <div>Timezone Unavailable</div>
    <button>
      <span (click)="modelclose()" class="common-close">&times;</span>
    </button>
  </div>

  <div class="panel-body">
    <ng-container>
      <div class="list-group app-form">
        <form [formGroup]="freeLauchtimezoneFrom">
          <div class="form-group">
            <div class="row">
              <div class="col-sm-12 pt-10">
                <div class="text-info p-l" role="alert">
                  *Info: Your profile is missing a timezone. Please update it with the timezone corresponding to your service
                  location. Timezone is mandatory for creating a job/candidate. Please select a timezone from the listing below.
                </div>
              </div>
                <div class="row form-group ">
                  <label class="control-label col-sm-3 required-field text-right font-light">Location</label>

                  <div class="col-sm-7">
                    <div class="row form-group">
                      <div class="col-sm-6">
                        <select class="form-control input-sm" formControlName="country"
                          (change)="onChangeCountrypatchvalue($event.target.value)">
                          <option value="null" disabled selected>Country</option>
                          <option *ngFor="let country of countryList" [value]="country.countryCode">{{country.countryName}}
                          </option>
                        </select>
                        <div
                          *ngIf="getcontrolforFreelaucher.country.invalid && (getcontrolforFreelaucher.country.dirty || getcontrolforFreelaucher.country.touched)">
                          <div class="red" *ngIf="getcontrolforFreelaucher.country.errors?.required">
                            Country is Required
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-6" *ngIf="getcontrolforFreelaucher.country.value !='US' && stateList.length === 0">
                        <input type="text" placeholder="State" id="other" formControlName="state" class="form-control input-sm"
                          maxlength="51">
                        <div class="red"
                          *ngIf="getcontrolforFreelaucher.state.invalid && (getcontrolforFreelaucher.state.dirty || getcontrolforFreelaucher.state.touched)">
                          <div *ngIf="getcontrolforFreelaucher.state.errors?.required">
                            State is Required
                          </div>
                          <div *ngIf="getcontrolforFreelaucher.state.errors?.maxword">
                            {{FORMERROR.STATE_MAX}}
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-6" *ngIf="getcontrolforFreelaucher.country.value !='US' && stateList.length > 0">
                        <select class="form-control input-sm" formControlName="state">
                          <option value="null" disabled selected>State</option>
                          <option *ngFor="let state of stateList" [value]="state.stateName">{{state.stateName}}
                          </option>
                        </select>
                        <div
                          *ngIf="getcontrolforFreelaucher.state.invalid && (getcontrolforFreelaucher.state.dirty || getcontrolforFreelaucher.state.touched)">
                          <div class="red" *ngIf="getcontrolforFreelaucher.state.errors?.required">
                            State is Required
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-6" *ngIf="getcontrolforFreelaucher.country.value ==='US'">
                        <input type="text" maxlength="12" placeholder="Zipcode" formControlName="zipcode"
                          class="form-control input-sm" (keyup)="getCities($event.target.value)">
                        <div class="red"
                          *ngIf="getcontrolforFreelaucher.zipcode.invalid && (getcontrolforFreelaucher.zipcode.dirty || getcontrolforFreelaucher.zipcode.touched)">
                          <div *ngIf="getcontrolforFreelaucher.zipcode.errors?.required">
                            Zipcode is Required
                          </div>
                          <div class="w-wrap" *ngIf="getcontrolforFreelaucher.zipcode.errors.minword">
                            {{FORMERROR.ZIPCODE_MIN}}
                          </div>
                          <div class="w-wrap" *ngIf="getcontrolforFreelaucher.zipcode.errors.maxword">
                            {{FORMERROR.ZIPCODE_MAX}}
                          </div>
                        </div>

                      </div>

                    </div>

                    <div class="row ">
                      <div class="col-sm-6">
                        <input type="text" placeholder="City" formControlName="city" class="form-control input-sm"
                          maxlength="51">
                        <div
                          *ngIf="getcontrolforFreelaucher.city.invalid && (getcontrolforFreelaucher.city.dirty || getcontrolforFreelaucher.city.touched)">
                          <div class="red" *ngIf="getcontrolforFreelaucher.city.errors?.required">
                            City is Required
                          </div>
                          <div class="red" *ngIf="getcontrolforFreelaucher.city.errors?.maxword">
                            {{FORMERROR.CITY_MAX}}
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6" *ngIf="getcontrolforFreelaucher.country.value ==='US'">
                        <input type="text" placeholder="State" id="other" formControlName="state" class="form-control input-sm"
                          maxlength="51">
                        <div class="red"
                          *ngIf="getcontrolforFreelaucher.state.invalid && (getcontrolforFreelaucher.state.dirty || getcontrolforFreelaucher.state.touched)">
                          <div *ngIf="getcontrolforFreelaucher.state.errors?.required">
                            State is Required
                          </div>
                          <div *ngIf="getcontrolforFreelaucher.state.errors?.maxword">
                            {{FORMERROR.STATE_MAX}}
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-6" *ngIf="getcontrolforFreelaucher.country.value !='US'">
                        <input type="text" maxlength="12" placeholder="Zipcode" formControlName="zipcode"
                          class="form-control input-sm">
                        <div class="red"
                          *ngIf="getcontrolforFreelaucher.zipcode.invalid && (getcontrolforFreelaucher.zipcode.dirty || getcontrolforFreelaucher.zipcode.touched)">
                          <div *ngIf="getcontrolforFreelaucher.zipcode.errors?.required">
                            Zipcode is Required
                          </div>
                          <div class="w-wrap" *ngIf="getcontrolforFreelaucher.zipcode.errors.minword">
                            {{FORMERROR.ZIPCODE_MIN}}
                          </div>
                          <div class="w-wrap" *ngIf="getcontrolforFreelaucher.zipcode.errors.maxword">
                            {{FORMERROR.ZIPCODE_MAX}}
                          </div>
                        </div>

                      </div>

                    </div>

                  </div>

                </div>
                <div  class="form-group row">
                  <label class="col-sm-3 control-label required-field text-right font-light">Timezones </label>
                  <div class="col-sm-7">
                    <select class="form-control input-sm" type="text" formControlName="timeZone">
                      <option value="null" selected disabled>Select Timezones</option>
                      <option *ngFor="let timeZone of timezoneslist" [value]="timeZone">{{timeZone}}</option>
                    </select>
                    <div
                      *ngIf="getcontrolforFreelaucher.timeZone.invalid && (getcontrolforFreelaucher.timeZone.dirty || getcontrolforFreelaucher.timeZone.touched)">
                      <div class="red" *ngIf="getcontrolforFreelaucher.timeZone.errors?.required">
                        Time zone is Required
                      </div>
                    </div>
                  </div>

                </div>

              </div>
            </div>
        </form>
      </div>
    </ng-container>
  </div>

  <div class="custom-panel-footer">
    <div class="panel-footer">
      <div class="footer-flex">
        <button class="btn btn-default " (click)="modelclose()">Cancel</button>
        <button class="btn  btn-primary " (click)="saveusertimezone()"
          type="submit">Submit</button>
      </div>
    </div>
  </div>
</ng-template>
